export default __webpack_public_path__ + "static/media/ficha-matricula.8412b0f9.png";